import { render, staticRenderFns } from "./UkFrontOfPackConfiguration.vue?vue&type=template&id=2e58af56&scoped=true"
import script from "./UkFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./UkFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e58af56",
  null
  
)

export default component.exports